import { FormControl, FormField, FormItem, FormLabel, FormMessage } from '@1trading/react/components/ui/form';
import { RadioGroup, RadioGroupItem, RadioGroupItemCard } from '@1trading/react/components/ui/radio-group';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { PageHeading, PageHeadingTitle } from '@/components/ui/page-heading';
import type { AmlQuestionnaireFiatDeposit } from '@/features/onboarding/aml-questionnaire/schema';
import { useIsPeriodicReview } from '@/features/periodic-review/context';
import { useAutoNextStep } from '@/hooks/use-auto-next-step';
import { AML_MONETARY_ANSWERS } from '@/services/api/profile';

const AmlQuestionnaireFieldsetFiatDepositLegend = () => {
  const { t } = useTranslation();

  return (
    <PageHeading asChild>
      <legend>
        <PageHeadingTitle>{t('AMLQuestionnaire.depositFiatPerMonth.title')}</PageHeadingTitle>
      </legend>
    </PageHeading>
  );
};
AmlQuestionnaireFieldsetFiatDepositLegend.displayName = 'AmlQuestionnaireFieldsetFiatDepositLegend';

const AmlQuestionnaireFieldsetFiatDeposit = () => {
  const form = useFormContext<AmlQuestionnaireFiatDeposit>();
  // A review prefills every answer and offers Continue, where moving on as well could skip a question the customer never saw
  const nextStepDeferred = useAutoNextStep(useIsPeriodicReview());
  const { t } = useTranslation();

  return (
    <FormField
      name="depositFiatPerMonth"
      control={form.control}
      render={({ field }) => (
        <FormItem>
          <FormLabel className="sr-only">{t('AMLQuestionnaire.depositFiatPerMonth.title')}</FormLabel>
          <FormControl>
            <RadioGroup
              className="!mt-0"
              defaultValue={field.value}
              variant="cards"
              aria-label={t('AMLQuestionnaire.depositFiatPerMonth.title')}
              onValueChange={(value) => {
                field.onChange(value);
                nextStepDeferred();
              }}
            >
              {AML_MONETARY_ANSWERS.map((answer) => (
                <FormItem key={answer}>
                  <RadioGroupItemCard variant="outline">
                    <FormControl>
                      <RadioGroupItem value={answer} />
                    </FormControl>
                    <FormLabel contained onClick={() => nextStepDeferred()}>
                      {t(`AMLQuestionnaire.depositFiatPerMonth.options.${answer}`)}
                    </FormLabel>
                  </RadioGroupItemCard>
                </FormItem>
              ))}
            </RadioGroup>
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};
AmlQuestionnaireFieldsetFiatDeposit.displayName = 'AmlQuestionnaireFieldsetFiatDeposit';
AmlQuestionnaireFieldsetFiatDeposit.isAutoNextStep = true;

export { AmlQuestionnaireFieldsetFiatDeposit, AmlQuestionnaireFieldsetFiatDepositLegend };
